
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSettingsStore } from '../store/useSettingsStore';
import { scrollToElement } from '../utils/transitions';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Menu, X } from 'lucide-react';

interface MobileMenuProps {
  sections: string[];
}

const MobileMenu: React.FC<MobileMenuProps> = ({ sections }) => {
  const { t } = useTranslation();
  const { language } = useSettingsStore();
  const [isOpen, setIsOpen] = React.useState(false);

  const handleNavClick = (id: string) => {
    // Handle special case for home/accueil
    if (id === 'home' || id === 'accueil') {
      scrollToElement('hero', 80);
    } else {
      scrollToElement(id, 80);
    }
    setIsOpen(false);
  };

  const translateSection = (section: string) => {
    if (language === 'fr') {
      switch (section) {
        case 'home': return 'Accueil';
        case 'about': return 'À propos';
        case 'resume': return 'CV';
        case 'certifications': return 'Certifications';
        case 'projects': return 'Projets';
        case 'experience': return 'Expérience';
        case 'services': return 'Mes services';
        case 'contact': return 'Contact';
        default: return section;
      }
    } else {
      switch (section) {
        case 'home': return 'Home';
        case 'about': return 'About';
        case 'resume': return 'Resume';
        case 'certifications': return 'Certifications';
        case 'projects': return 'Projects';
        case 'experience': return 'Experience';
        case 'services': return 'My Services';
        case 'contact': return 'Contact';
        default: return section;
      }
    }
  };

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <button 
          className="flex items-center justify-center p-2 rounded-md focus:outline-none"
          aria-label="Menu"
        >
          <Menu className="h-6 w-6" />
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="glass-morphism border-l border-white/10 backdrop-blur-xl">
        <div className="flex justify-end">
          <button 
            onClick={() => setIsOpen(false)} 
            className="p-2"
          >
            <X className="h-6 w-6" />
          </button>
        </div>
        <nav className="flex flex-col gap-6 pt-6">
          {sections.map((item) => (
            <button
              key={item}
              className="text-lg py-2 uppercase tracking-wider hover:text-cyan-400 transition-colors duration-300 text-left"
              onClick={() => handleNavClick(item)}
            >
              {translateSection(item)}
            </button>
          ))}
        </nav>
      </SheetContent>
    </Sheet>
  );
};

export default MobileMenu;
